import React from 'react';
const POINTS = [{
  icon: '🔧',
  title: 'Practical diagnostic references',
  body: 'Find the symptom, system or test you need while troubleshooting gasoline engines.'
}, {
  icon: '🔍',
  title: 'Structured fault-finding system',
  body: 'Move from the initial complaint to testing, interpretation and root-cause verification.'
}, {
  icon: '⚡',
  title: '6 diagnostic areas',
  body: 'Engine fundamentals, fuel, ignition, sensors, drivability and advanced testing.'
}, {
  icon: '🔄',
  title: 'Ready to use again and again',
  body: 'Return to the system whenever you need to troubleshoot a gasoline engine fault.'
}];
export function NotEbook() {
  return <section className="bg-navy py-6 sm:py-9" data-id="element-112" data-mp="1nat0yvqf0cx">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-113" data-mp="1m9doi7onrpe">
        <h2 className="text-center text-[22px] leading-[1.05] text-white sm:text-[36px]" data-id="element-114" data-mp="1yhxh2ye2m8mi">
          This isn't just another automotive ebook
        </h2>
        <p className="mt-1.5 text-center font-display text-[16px] font-semibold uppercase leading-tight text-diag sm:text-[23px]" data-id="element-115" data-mp="2er1wbao7zbvj">
          It's a ready-to-use visual diagnostic system.
        </p>

        <div className="mt-4 grid gap-2.5 sm:grid-cols-2 sm:gap-3" data-id="element-116" data-mp="2518mae3q74te">
          {POINTS.map(point => <div key={point.title} className="flex gap-3 rounded-md border border-navyline bg-navy2 p-3.5 sm:p-4" data-id="element-117" data-mp="202fjbfm2ew7h">
              <span className="text-[21px] leading-none" aria-hidden="true" data-id="element-118" data-mp="2xp4q02rppwzo">
                {point.icon}
              </span>
              <div data-id="element-119" data-mp="2nrqac5dm5c8f">
                <h3 className="text-[15px] leading-tight text-white sm:text-[18px]" data-id="element-120" data-mp="2nr72xilla68n">
                  {point.title}
                </h3>
                <p className="mt-1 text-[13.5px] font-medium leading-snug text-steellight sm:text-[15px]" data-id="element-121" data-mp="2jpljfeejutph">
                  {point.body}
                </p>
              </div>
            </div>)}
        </div>

        <p className="mt-4 text-center font-display text-[15px] font-semibold uppercase tracking-wide text-white sm:text-[20px]" data-id="element-122" data-mp="18d2ks023osjc">
          Less searching. Less guessing.{' '}
          <span className="text-diag" data-id="element-123" data-mp="1eqq0a2q5k18j">More diagnostic clarity.</span>
        </p>
      </div>
    </section>;
}